/* eslint-disable no-param-reassign */
const GESTURES = ['click', 'touchend', 'keydown'];

/**
 * On the first user gesture on `target`, play `audio` muted and stop it again. Safari only lets an element play
 * later, outside a gesture, after it has played inside one. Runs once; a refused priming play is ignored.
 */
const unlockOnGesture = (target, audio) => {
  const prime = () => {
    GESTURES.forEach((type) => target.removeEventListener(type, prime, true));
    if (!audio.paused) return;
    audio.muted = true;
    const reset = () => {
      audio.pause();
      audio.currentTime = 0;
      audio.muted = false;
    };
    const started = audio.play();
    if (started && typeof started.then === 'function') started.then(reset, reset);
    else reset();
  };
  GESTURES.forEach((type) => target.addEventListener(type, prime, true));
};

module.exports = { unlockOnGesture };
